module.exports = __webpack_public_path__ + "static/media/P1080862_neu-min.d8ddd0b9.jpg";